import useSWR from 'swr'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosResponse } from 'axios'
import { useMemo } from 'react'

export interface CourtesyTicketsProps {
  ticket_gender: string
  ticket_id: string
  ticket_limite: string
  ticket_lote: string
  ticket_lote_id: string
  ticket_name: string
  ticket_title: string
  ticket_type: string
  ticket_value: string
}

export interface CourtesySectorProps {
  sector_id: string
  sector_name: string
  event_name?: string
  tickets: CourtesyTicketsProps[]
}

export type CourtesyPDVProps = {
  terminal_id: number
  pdv_serial: string
  pdv_id: number
  pdv_max: number
  pdv_rest_amount: number
  operador_id: number
  event_name: string
  event_date: string
}

export interface TrackerResponse {
  producerPDV: {
    pdv: CourtesyPDVProps
    courtesy: CourtesySectorProps[]
  }
  producerPDVLoading: boolean
  producerPDVError: string | null
}

export const useGetProducerPDV = (eventId: string): TrackerResponse => {
  const url: string = `/producer/app/v2/pdv/events?event_id=${eventId}`
  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR<any>(url, fetchData, {
    shouldRetryOnError: false,
  })

  const nestedData = useMemo(() => data?.data?.data || undefined, [data])

  const memoizedValue = useMemo(
    () => ({
      producerPDV: nestedData,
      producerPDVLoading: isLoading,
      producerPDVError: error,
    }),
    [nestedData, error, isLoading]
  )

  return memoizedValue
}
